import store from "@/store";

export default {
    methods: {
        getDeviceType() {
            if(!store.state.initialUrlParameters.hasOwnProperty('devicetype')) return '';
            return  store.state.initialUrlParameters.devicetype;
        },
        isIos() {
            return this.getDeviceType() === 'ios';
        },
        isAndroid() {
            return this.getDeviceType() === 'android';
        }
    }
}